import AudienceImpressionsResult, { IAudienceImpressionsResultAPI } from './AudienceImpressionsResult';
import CadenceImpressionFeasibility, { ICadenceImpressionFeasibilityAPI } from './CadenceFeasibility';
import TotalImpressionsByUnit, { IImpressionsForUnit, ITotalImpressionsByUnitAPI } from './TotalImpressionsByUnit';
import TotalImpressionsResult, { ITotalImpressionsResultAPI } from './TotalImpressionsResult';

interface IAvailsResultAPI {
  audience_impressions_result: IAudienceImpressionsResultAPI;
  availability_result: string;
  cadence_impression_feasibility: ICadenceImpressionFeasibilityAPI;
  optimized_impressions: number;
  strict_avails: boolean;
  predictive_avails_confidence_level: string;
  total_impressions_by_unit: ITotalImpressionsByUnitAPI;
  total_impressions_result: ITotalImpressionsResultAPI;
}

export default class AvailsResult {
  availabilityResult: string;

  totalImpressionsResult?: TotalImpressionsResult;

  audienceImpressionsResult?: AudienceImpressionsResult;

  totalImpressionsByUnit?: TotalImpressionsByUnit;

  strictAvails: boolean;

  predictiveAvailsConfidenceLevel?: string;

  cadenceImpressionFeasibility?: CadenceImpressionFeasibility;

  optimizedImpressions: number;

  apiObject?: IAvailsResultAPI;

  constructor(
    availabilityResult: string,
    totalImpressionsResult: TotalImpressionsResult | null,
    audienceImpressionsResult: AudienceImpressionsResult | null,
    totalImpressionsByUnit: TotalImpressionsByUnit | null,
    strictAvails: boolean,
    cadenceImpressionFeasibility: CadenceImpressionFeasibility | null,
    optimizedImpressions: number,
    predictiveAvailsConfidenceLevel: string | null,
  ) {
    this.availabilityResult = availabilityResult;
    this.totalImpressionsResult = totalImpressionsResult;
    this.audienceImpressionsResult = audienceImpressionsResult;
    this.totalImpressionsByUnit = totalImpressionsByUnit;
    this.strictAvails = strictAvails;
    this.cadenceImpressionFeasibility = cadenceImpressionFeasibility;
    this.optimizedImpressions = optimizedImpressions;
    this.predictiveAvailsConfidenceLevel = predictiveAvailsConfidenceLevel;
    this.apiObject = null;
  }

  impressionsForUnit(unitID: number): IImpressionsForUnit | number {
    return this.totalImpressionsByUnit?.impressionsForUnit(unitID) || 0;
  }

  get unitIDs(): string[] {
    return this.totalImpressionsByUnit?.unitIDs || [];
  }

  static fromApi(apiObject: IAvailsResultAPI): AvailsResult {
    const avails = new AvailsResult(
      apiObject.availability_result,
      apiObject.total_impressions_result != null
        ? TotalImpressionsResult.fromApi(apiObject.total_impressions_result)
        : null,
      apiObject.audience_impressions_result != null
        ? AudienceImpressionsResult.fromApi(apiObject.audience_impressions_result)
        : null,
      apiObject.total_impressions_by_unit != null
        ? TotalImpressionsByUnit.fromApi(apiObject.total_impressions_by_unit)
        : null,
      apiObject.strict_avails,
      apiObject.cadence_impression_feasibility != null
        ? CadenceImpressionFeasibility.fromApi(apiObject.cadence_impression_feasibility)
        : null,
      apiObject.optimized_impressions,
      apiObject.predictive_avails_confidence_level,
    );
    avails.apiObject = apiObject;
    return avails;
  }
}
